import AlarmsTableFactory from "../../factories/AlarmsTableFactory";
import NotificationsLogGetters from "./AlarmsLogGetters";
import NotificationsLogActions from "./AlarmsLogActions";
import NotificationsLogMutations from "./AlarmsLogMutations";

const state = AlarmsTableFactory.EmptyState();

const { getters } = NotificationsLogGetters;

const { actions } = NotificationsLogActions;

const { mutations } = NotificationsLogMutations;

const namespaced = true;

export default {
	state,
	namespaced,
	actions,
	mutations,
	getters
};